<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div v-else>
    <form v-scroll-to-error class="container" @submit.prevent="submitForm">
      <div class="form-header">
        <h1 class="title-screen">{{ adminText('adminAll.organization_info_3dcdfa', 'Organization info') }}</h1>
        <div v-if="userRole === 'OWNER'" class="edit" @click="toggleEditing()">
          <img src="/assets/edit-pen.svg" :alt="adminText('adminAll.edit_icon_d1541c', 'Edit icon')" class="edit-pen">
          <p class="edit-text">{{ enableEditing ? adminText('adminAll.cancel_1507c4', 'CANCEL') : adminText('adminAll.edit_17865b', 'EDIT') }}</p>
        </div>
      </div>
      <organizer-profile
        :admin-context="isAdminLocalization"
        :vs="$v"
        :initial-values="form"
        :enable-editing="enableEditing"
        @values="form = $event"
        @submit="submitForm"
      />
      <div v-if="deleteAccountDialog" class="delete-container">
        <h1 class="delete-title">{{ adminText('adminAll.delete_organization_c9746b', 'Delete organization') }}</h1>
        <p class="delete-description">
          {{ adminText('adminAll.are_you_sure_you_want_to_delete_your_organization_this_wil_2227ba', 'Are you sure you want to delete your organization? This will permanently delete your organization and your events associated with it.') }}
        </p>
        <div class="delete-buttons">
          <main-button :text="adminText('adminAll.cancel_77dfd2', 'Cancel')" outline @click="deleteAccountDialog = false" />
          <main-button :text="adminText('adminAll.delete_f6fdbe', 'Delete')" color="#DB384C" @click="deleteOrganization()" />
        </div>
      </div>
      <div v-if="deleteAccountDialog" class="delete-message" @click="deleteAccountDialog = false" />
    </form>
    <!-- <h1 class="titles">Delete organization</h1>
    <main-button
      :disabled="!enableEditing"
      text="Delete this organization"
      color="red"
      depressed
      class="delete-button"
      type="button"
      @click="deleteAccountDialog = true"
    /> -->
    <simple-snackbar v-bind.sync="snackbar" :message-prop="adminAllMessage(snackbar.messageProp)" />
  </div>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
import {
  DELETE_ORGANIZATION,
  GET_ORGANIZATION,
  UPDATE_ORGANIZATION,
} from '../../graphql/organization.graphql.js'
import { email, required } from 'vuelidate/lib/validators'
import { omit } from 'lodash'
import { httpUrl } from '@/validators'

import Spinner from '../shared/spinner'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar.vue'
import OrganizerProfile from './organizer-profile.vue'
import { submitGuard } from '../../utils'

export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'organizer-profile-container',
  components: { SimpleSnackbar, Spinner, OrganizerProfile },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    return {
      enableEditing: false,
      form: {},
      initialForm: {},
      snackbar: {},
      userRole: null,
      deleteAccountDialog: false,
    }
  },
  validations() {
    return {
      form: {
        publicName: {
          required,
        },
        email: {
          required,
          email,
        },
        description: {
          required,
        },
        facebookLink: { httpUrl },
        instagramLink: { httpUrl },
        linkedinLink: { httpUrl },
        youtubeLink: { httpUrl },
        webLink: { httpUrl },
      },
    }
  },
  methods: {
    async deleteOrganization() {
      // TODO - Enable this when selecting and creating flow is implemented
      const { errors } = await this.$apollo.mutate({
        mutation: DELETE_ORGANIZATION,
        variables: { organizationId: this.form.id },
      })

      if (errors) {
        this.snackbar = {
          open: true,
          messageProp: errors[0].message,
          color: 'error',
        }
      } else {
        window.location.reload()
      }
    },
    toggleEditing() {
      this.enableEditing = !this.enableEditing
    },
    async submitForm() {
      await submitGuard(this, async () => {
        const { errors } = await this.$apollo.mutate({
          mutation: UPDATE_ORGANIZATION,
          variables: {
            organizationId: this.form.id,
            organizationInfo: omit(this.form, ['id', '__typename']),
          },
          refetchQueries: [
            { query: GET_ORGANIZATION, variables: { organizationSlug: this.organizationSlug } },
          ],
        })
        this.snackbar = {
          open: true,
          messageProp: errors && errors.length > 0 ? errors[0].message : this.adminAllNotice('Account settings saved'),
          color: errors && errors.length > 0 ? 'error' : 'primary',
        }
        this.toggleEditing()
      })
    },
  },
  apollo: {
    getOrganization: {
      query: GET_ORGANIZATION,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
        }
      },
      result({ data, loading }) {
        if (!loading && data) {
          const { events, ...rest } = data.getOrganization
          this.form = omit(rest, ['liveEventsCount', 'userOrganization', 'organizationRole'])
          this.userRole = data.getOrganization.userOrganization.role
          this.initialForm = omit(data.getOrganization, ['liveEventsCount', 'userOrganization', 'organizationRole'])
        }
      },
    },
  },
}
</script>

<style scoped>
.edit-text {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 1.125rem;
  color: #0277bd;
  margin-bottom: 0;
}

.edit {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.edit-pen {
  height: 1.125rem;
  width: 1.125rem;
  margin-right: 0.625rem;
}

.form-header {
  display: flex;
  justify-content: space-between;
}

.container {
  max-width: 43.75rem;
  margin: 0 !important;
  padding: 0 !important;
}

.delete-message {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  background: white;
  opacity: 80%;
  z-index: 500;
}

.delete-container {
  width: 31.25rem;
  z-index: 1000;
  background: white;
  position: fixed;
  max-width: 80%;
  text-align: center;
  border-radius: 0.5rem;
  top: 25%;
  left: 50%;
  filter: drop-shadow(0px 0px 24px rgba(51, 51, 51, 0.2));
  padding: 1.25rem;
  transform: translate(-50%, 0);
}

.delete-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: -0.03em;
  color: #0277bd;
  margin-bottom: 1.5rem;
}

.delete-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #666666;
}

.delete-buttons {
  display: flex;
  justify-content: flex-end;
}
</style>
